const Layout = ({ children }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <div style={{ flex: 1 }}>
                {children}
            </div>

            <div>
                <footer className="layout_footer">
                    ©Copyright 2023 COOTRANSFUSA Todos los derechos reservados <br />
                    Desarrollado por el Área de Sistemas
                </footer>
            </div>
        </div>
    );
}

export default Layout;